module.exports = __webpack_public_path__ + "img/google-drive.19977565.svg";